import styled from 'styled-components';

export const PFooter = styled.div`
  border-top: 1px solid var(--LightGray);
  justify-content: flex-end;
  padding: 30px 30px;
  margin-top: 20px;
  min-width: 292px;
  display: flex;
`;

export const PTop = styled.div`
  padding: 10px 50px;
`;

export const PTopWrapper = styled.div`
  padding-top: 10px;
  width: 45%;
`;
